export default __webpack_public_path__ + "static/media/twitter.755f671f.png";